// third-party
import { FormattedMessage } from 'react-intl';

// ==============================|| MENU ITEMS - PAGES ||============================== //

const pages = [
  {
    id: 'active-users-dashboard',
    title: <FormattedMessage id="active-users-dashboard" />,
    type: 'item',
    url: '/active-users',
    target: false
  },
  {
    id: 'ifoods-dashboard',
    title: <FormattedMessage id="ifoods-dashboard" />,
    type: 'item',
    url: '/ifoods-dashboard',
    target: false
  },
  {
    id: 'bank-master',
    title: <FormattedMessage id="bank-master" />,
    type: 'item',
    url: '/bank-master',
    target: false
  },
  {
    id: 'company-master',
    title: <FormattedMessage id="company-master" />,
    type: 'item',
    url: '/company-master',
    target: false
  },
  {
    id: 'claim-location-category',
    title: <FormattedMessage id="claim-location-category" />,
    type: 'item',
    url: '/claim-location-category',
    target: false
  },
  {
    id: 'claim-frequency-type',
    title: <FormattedMessage id="claim-frequency-type" />,
    type: 'item',
    url: '/claim-frequency-type',
    target: false
  },
  {
    id: 'claim-frequency-master',
    title: <FormattedMessage id="claim-frequency-master" />,
    type: 'item',
    url: '/claim-frequency-master',
    target: false
  },
  {
    id: 'claim-approval-level-control',
    title: <FormattedMessage id="claim-approval-level-control" />,
    type: 'item',
    url: '/claim-approval-level-control',
    target: false
  },
  {
    id: 'event-master',
    title: <FormattedMessage id="event-master" />,
    type: 'item',
    url: '/event-master',
    target: false
  },
  {
    id: 'gl-master',
    title: <FormattedMessage id="gl-master" />,
    type: 'item',
    url: '/gl-master',
    target: false
  },
  {
    id: 'fd-competitor-master',
    title: <FormattedMessage id="fd-competitor-master" />,
    type: 'item',
    url: '/fd-competitor-master',
    target: false
  },
  {
    id: 'ifd-competitor-master',
    title: <FormattedMessage id="ifd-competitor-master" />,
    type: 'item',
    url: '/ifd-competitor-master',
    target: false,
    children: [
      {
        id: 'create-competitor-master',
        title: <FormattedMessage id="create-competitor-master" />,
        type: 'item',
        url: '/ifd-competitor-master/create',
        target: false
      },
      {
        id: 'edit-competitor-master',
        title: <FormattedMessage id="edit-competitor-master" />,
        type: 'item',
        url: '/ifd-competitor-master/edit',
        target: false
      }
    ]
  },
  {
    id: 'competitor-offers',
    title: <FormattedMessage id="competitor-offers" />,
    type: 'item',
    url: '/competitor-offers',
    target: false
  },
  {
    id: 'claim-master',
    title: <FormattedMessage id="claim-master" />,
    type: 'item',
    url: '/claim-master',
    target: false
  },
  {
    id: 'customer-master',
    title: <FormattedMessage id="customer-master" />,
    type: 'item',
    url: '/customer-master',
    target: false
  },
  {
    id: 'division-master',
    title: <FormattedMessage id="division-master" />,
    type: 'item',
    url: '/division-master',
    target: false,
    children: [
      {
        id: 'create-division-master',
        title: <FormattedMessage id="create-division-master" />,
        type: 'item',
        url: '/division-master/create',
        target: false
      },
      {
        id: 'edit-division-master',
        title: <FormattedMessage id="edit-division-master" />,
        type: 'item',
        url: '/division-master/edit',
        target: false
      }
    ]
  },
  {
    id: 'dropdown-master',
    title: <FormattedMessage id="dropdown-master" />,
    type: 'item',
    url: '/dropdown-master',
    target: false
  },
  {
    id: 'location-master',
    title: <FormattedMessage id="location-master" />,
    type: 'item',
    url: '/location-master',
    target: false
  },
  {
    id: 'menu-master',
    title: <FormattedMessage id="menu-master" />,
    type: 'item',
    url: '/menu-master',
    target: false
  },
  {
    id: 'outlet-master',
    title: <FormattedMessage id="outlet-master" />,
    type: 'item',
    url: '/outlet-master',
    target: false,
    children: [
      {
        id: 'create-outlet-master',
        title: <FormattedMessage id="create-outlet-master" />,
        type: 'item',
        url: '/outlet-master/create',
        target: false
      },
      {
        id: 'edit-outlet-master',
        title: <FormattedMessage id="edit-outlet-master" />,
        type: 'item',
        url: '/outlet-master/edit',
        target: false
      }
    ]
  },
  {
    id: 'plant-master',
    title: <FormattedMessage id="plant-master" />,
    type: 'item',
    url: '/plant-master',
    target: false,
    children: [
      {
        id: 'create-plant-master',
        title: <FormattedMessage id="create-plant-master" />,
        type: 'item',
        url: '/plant-master/create',
        target: false
      },
      {
        id: 'edit-plant-master',
        title: <FormattedMessage id="edit-plant-master" />,
        type: 'item',
        url: '/plant-master/edit',
        target: false
      }
    ]
  },
  {
    id: 'plan-applicable',
    title: <FormattedMessage id="plan-applicable" />,
    type: 'item',
    url: '/plan-applicable',
    target: false
  },
  {
    id: 'product-master',
    title: <FormattedMessage id="product-master" />,
    type: 'item',
    url: '/product-master',
    target: false
  },
  {
    id: 'prospect-master',
    title: <FormattedMessage id="prospect-master" />,
    type: 'item',
    url: '/prospect-master',
    target: false
  },
  {
    id: 'role-master',
    title: <FormattedMessage id="role-master" />,
    type: 'item',
    url: '/role-master',
    target: false
  },
  {
    id: 'shift-master',
    title: <FormattedMessage id="shift-master" />,
    type: 'item',
    url: '/shift-master',
    target: false,
    children: [
      {
        id: 'create-shift-master',
        title: <FormattedMessage id="create-shift-master" />,
        type: 'item',
        url: '/shift-master/create',
        target: false
      },
      {
        id: 'edit-shift-master',
        title: <FormattedMessage id="edit-shift-master" />,
        type: 'item',
        url: '/shift-master/edit',
        target: false
      }
    ]
  },
  {
    id: 'user-master',
    title: <FormattedMessage id="user-master" />,
    type: 'item',
    url: '/user-master',
    target: false,
    children: [
      {
        id: 'create-user-master',
        title: <FormattedMessage id="create-user-master" />,
        type: 'item',
        url: '/user-master/create',
        target: false
      },
      {
        id: 'edit-user-master',
        title: <FormattedMessage id="edit-user-master" />,
        type: 'item',
        url: '/user-master/edit',
        target: false
      }
    ]
  },
  {
    id: 'venue-master',
    title: <FormattedMessage id="venue-master" />,
    type: 'item',
    url: '/venue-master',
    target: false,
    children: [
      {
        id: 'edit-venue-mapping',
        title: <FormattedMessage id="edit-venue-mapping" />,
        type: 'item',
        url: '/venue-master/edit',
        target: false
      }
    ]
  },
  {
    id: 'zone-master',
    title: <FormattedMessage id="zone-master" />,
    type: 'item',
    url: '/zone-master',
    target: false
  },
  {
    id: 'primary-material-mapping',
    title: <FormattedMessage id="primary-material-mapping" />,
    type: 'item',
    url: '/primary-material-mapping',
    target: false
  },
  {
    id: 'settings',
    title: <FormattedMessage id="settings" />,
    type: 'item',
    url: '/settings',
    target: false
  },
  {
    id: 'employee-master',
    title: <FormattedMessage id="employee-master" />,
    type: 'item',
    url: '/employee-master',
    target: false,
    children: [
      {
        id: 'create-employee-master',
        title: <FormattedMessage id="create-employee-master" />,
        type: 'item',
        url: '/employee-master/create',
        target: false
      },
      {
        id: 'edit-employee-master',
        title: <FormattedMessage id="edit-employee-master" />,
        type: 'item',
        url: '/employee-master/edit',
        target: false
      }
    ]
  },
  {
    id: 'ifoods-plan',
    title: <FormattedMessage id="ifoods-plan-approval" />,
    type: 'item',
    url: '/ifoods-plan',
    target: false
  },
  {
    id: 'foods-plan',
    title: <FormattedMessage id="foods-plan-approval" />,
    type: 'item',
    url: '/foods-plan',
    target: false
  },
  {
    id: 'pjp-creation',
    title: <FormattedMessage id="pjp-creation" />,
    type: 'item',
    url: '/pjp-creation',
    target: false,
    children: [
      {
        id: 'create-plan',
        title: <FormattedMessage id="create-plan" />,
        type: 'item',
        url: '/pjp-creation/create',
        target: false
      },
      {
        id: 'edit-plan',
        title: <FormattedMessage id="edit-plan" />,
        type: 'item',
        url: '/pjp-creation/edit',
        target: false
      }
    ]
  },
  {
    id: 'calendar-event',
    title: <FormattedMessage id="calendar-event" />,
    type: 'item',
    url: '/calendar-event',
    target: false,
    children: [
      {
        id: 'create-calendar-event',
        title: <FormattedMessage id="create-calendar-event" />,
        type: 'item',
        url: '/calendar-event/create',
        target: false
      }
    ]
  },
  {
    id: 'claim-creation',
    title: <FormattedMessage id="claim-creation" />,
    type: 'item',
    url: '/claim-creation',
    target: false
  },
  {
    id: 'target',
    title: <FormattedMessage id="target" />,
    type: 'item',
    url: '/target',
    target: false
  },
  {
    id: 'plan-validation',
    title: <FormattedMessage id="plan-validation" />,
    type: 'item',
    url: '/plan-validation',
    target: false
  },
  {
    id: 'plan-validation-manager',
    title: <FormattedMessage id="plan-validation-manager" />,
    type: 'item',
    url: '/plan-validation-manager',
    target: false
  },
  // {
  //   id: 'plan-deviation',
  //   title: <FormattedMessage id="plan-deviation-validation" />,
  //   type: 'item',
  //   url: '/plan-deviation',
  // },
  {
    id: 'plan-deviation-approval-backoffice',
    title: <FormattedMessage id="plan-deviation-approval-backoffice" />,
    type: 'item',
    url: '/plan-deviation-approval-backoffice',
    target: false,
    children: [
      {
        id: 'edit-plan-deviation',
        title: <FormattedMessage id="edit-plan-deviation" />,
        type: 'item',
        url: '/plan-deviation-approval-backoffice/edit',
        target: false
      }
    ]
  },
  {
    id: 'plan-deviation-approval-manager',
    title: <FormattedMessage id="plan-deviation-approval-manager" />,
    type: 'item',
    url: '/plan-deviation-approval-manager',
    target: false,
    children: [
      {
        id: 'edit-plan-deviation',
        title: <FormattedMessage id="edit-plan-deviation" />,
        type: 'item',
        url: '/plan-deviation-approval-manager/edit',
        target: false
      }
    ]
  },
  {
    id: 'prospect-validation',
    title: <FormattedMessage id="ifoods-prospect-validation" />,
    type: 'item',
    url: '/prospect-validation',
    target: false
  },
  {
    id: 'common-notification',
    title: <FormattedMessage id="common-notification" />,
    type: 'item',
    url: '/common-notification',
    target: false,
    children: [
      {
        id: 'edit-common-notification',
        title: <FormattedMessage id="edit-common-notification" />,
        type: 'item',
        url: '/common-notification/edit',
        target: false
      }
    ]
  },
  {
    id: 'approval-secondary-customer',
    title: <FormattedMessage id="approval-secondary-customer" />,
    type: 'item',
    url: '/approval-secondary-customer',
    target: false,
    children: [
      {
        id: 'edit-approval-secondary-customer',
        title: <FormattedMessage id="edit-approval-secondary-customer" />,
        type: 'item',
        url: '/approval-secondary-customer/edit',
        target: false
      }
    ]
  },
  {
    id: 'approval-claim-backoffice',
    title: <FormattedMessage id="approval-claim-backoffice" />,
    type: 'item',
    url: '/approval-claim-backoffice',
    target: false,
    children: [
      {
        id: 'edit-approval-claim-backoffice',
        title: <FormattedMessage id="edit-approval-claim-backoffice" />,
        type: 'item',
        url: '/approval-claim-backoffice/edit',
        target: false
      }
    ]
  },
  {
    id: 'approval-claim-executive',
    title: <FormattedMessage id="approval-claim-executive" />,
    type: 'item',
    url: '/approval-claim-executive',
    target: false,
    children: [
      {
        id: 'edit-approval-claim-executive',
        title: <FormattedMessage id="view-approval-claim-executive" />,
        type: 'item',
        url: '/approval-claim-executive/edit',
        target: false
      }
    ]
  },
  {
    id: 'approval-claim-manager',
    title: <FormattedMessage id="approval-claim-manager" />,
    type: 'item',
    url: '/approval-claim-manager',
    target: false,
    children: [
      {
        id: 'view-approval-claim-manager',
        title: <FormattedMessage id="view-approval-claim-manager" />,
        type: 'item',
        url: '/approval-claim-manager/view',
        target: false
      },
      {
        id: 'edit-approval-claim-manager',
        title: <FormattedMessage id="edit-approval-claim-manager" />,
        type: 'item',
        url: '/approval-claim-manager/edit',
        target: false
      }
    ]
  },
  {
    id: 'regular-approval-claim-reporting-manager',
    title: <FormattedMessage id="approval-claim-backoffice" />,
    type: 'item',
    url: '/regular-approval-claim-reporting-manager',
    target: false,
    children: [
      {
        id: 'edit-regular-approval-claim-reporting-manager',
        title: <FormattedMessage id="edit-regular-approval-claim-reporting-manager" />,
        type: 'item',
        url: '/regular-approval-claim-reporting-manager/edit',
        target: false
      }
    ]
  },
  {
    id: 'regular-approval-claim-division-manager',
    title: <FormattedMessage id="approval-claim-division-manager" />,
    type: 'item',
    url: '/regular-approval-claim-division-manager',
    target: false,
    children: [
      {
        id: 'edit-regular-approval-claim-division-manager',
        title: <FormattedMessage id="edit-regular-approval-claim-division-manager" />,
        type: 'item',
        url: '/regular-approval-claim-division-manager/edit',
        target: false
      }
    ]
  },
  {
    id: 'regular-approval-claim-hr',
    title: <FormattedMessage id="approval-claim-hr" />,
    type: 'item',
    url: '/regular-approval-claim-hr',
    target: false,
    children: [
      {
        id: 'edit-regular-approval-claim-hr',
        title: <FormattedMessage id="edit-regular-approval-claim-hr" />,
        type: 'item',
        url: '/regular-approval-claim-hr/edit',
        target: false
      }
    ]
  },
  {
    id: 'regular-approval-claim-accounts-executive',
    title: <FormattedMessage id="approval-claim-accounts-executive" />,
    type: 'item',
    url: '/regular-approval-claim-accounts-executive',
    target: false,
    children: [
      {
        id: 'edit-regular-approval-claim-accounts-executive',
        title: <FormattedMessage id="edit-regular-approval-claim-accounts-executive" />,
        type: 'item',
        url: '/regular-approval-claim-accounts-executive/edit',
        target: false
      }
    ]
  },
  {
    id: 'regular-approval-claim-accounts-manager',
    title: <FormattedMessage id="approval-claim-accounts-manager" />,
    type: 'item',
    url: '/regular-approval-claim-accounts-manager',
    target: false,
    children: [
      {
        id: 'edit-regular-approval-claim-accounts-manager',
        title: <FormattedMessage id="edit-regular-approval-claim-accounts-manager" />,
        type: 'item',
        url: '/regular-approval-claim-accounts-manager/edit',
        target: false
      },
       {
        id: 'claim-smart-form',
        title: <FormattedMessage id="claim-smart-form" />,
        type: 'item',
        url: '/regular-approval-claim-accounts-manager/view',
        target: false
      }
    ]
  },
  {
    id: 'attendance-report',
    title: <FormattedMessage id="attendance-report" />,
    type: 'item',
    url: '/attendance-report',
    target: false
  },
   {
    id: 'user-report',
    title: <FormattedMessage id="user-report" />,
    type: 'item',
    url: '/user-report',
    target: false
  },
  {
    id: 'app-track-report',
    title: <FormattedMessage id="app-track-report" />,
    type: 'item',
    url: '/app-track-report',
    target: false
  },
  {
    id: 'competitor-report',
    title: <FormattedMessage id="competitor-report" />,
    type: 'item',
    url: '/competitor-report',
    target: false
  },
  {
    id: 'claim-details-report',
    title: <FormattedMessage id="claim-details-report" />,
    type: 'item',
    url: '/claim-details-report',
    target: false,
    children: [
      {
        id: 'view-claim-details-report',
        title: <FormattedMessage id="view-claim-details-report" />,
        type: 'item',
        url: '/claim-details-report/view',
        target: false
      },
     
    ]
  },
  {
    id: 'claim-expense-report',
    title: <FormattedMessage id="claim-expense-report" />,
    type: 'item',
    url: '/claim-expense-report',
    target: false
  },
  {
    id: 'claim-status-log',
    title: <FormattedMessage id="claim-status-log" />,
    type: 'item',
    url: '/claim-status-log',
    target: false
  },
  {
    id: 'claim-log',
    title: <FormattedMessage id="claim-log" />,
    type: 'item',
    url: '/claim-log',
    target: false
  },
  {
    id: 'claim-expense-log',
    title: <FormattedMessage id="claim-expense-log" />,
    type: 'item',
    url: '/claim-expense-log',
    target: false
  },
  {
    id: 'dashboard-slider',
    title: <FormattedMessage id="dashboard-slider" />,
    type: 'item',
    url: '/dashboard-slider',
    target: false
  },
  {
    id: 'plan-report',
    title: <FormattedMessage id="plan-report" />,
    type: 'item',
    url: '/plan-report',
    target: false,
    children: [
      {
        id: 'view-plan-report',
        title: <FormattedMessage id="view-plan-report" />,
        type: 'item',
        url: '/plan-report/view',
        target: false
      }
    ]
  },
  {
    id: 'pjp-report',
    title: <FormattedMessage id="pjp-report" />,
    type: 'item',
    url: '/pjp-report',
    target: false
  },
  {
    id: 'plan-details-report',
    title: <FormattedMessage id="plan-details-report" />,
    type: 'item',
    url: '/plan-details-report',
    target: false
  },
  {
    id: 'plan-deviation-report',
    title: <FormattedMessage id="plan-deviation-report" />,
    type: 'item',
    url: '/plan-deviation-report',
    target: false
  },
  {
    id: 'map-view',
    title: <FormattedMessage id="map-view" />,
    type: 'item',
    url: '/map-view',
    target: false
  },
  {
    id: 'map',
    title: <FormattedMessage id="map" />,
    type: 'item',
    url: '/map',
    target: false
  },
  {
    id: 'outlet-visit-report',
    title: <FormattedMessage id="outlet-visit-report" />,
    type: 'item',
    url: '/outlet-visit-report',
    target: false
  },
  {
    id: 'secondary-order-report',
    title: <FormattedMessage id="secondary-order-report" />,
    type: 'item',
    url: '/secondary-order-report',
    target: false
  },
  {
    id: 'primary-customer-visit-report',
    title: <FormattedMessage id="primary-customer-visit-report" />,
    type: 'item',
    url: '/primary-customer-visit-report',
    target: false
  },
  {
    id: 'secondary-outlet-visit-report',
    title: <FormattedMessage id="secondary-outlet-visit-report" />,
    type: 'item',
    url: '/secondary-outlet-visit-report',
    target: false
  },
  {
    id: 'prospect-report',
    title: <FormattedMessage id="prospect-report" />,
    type: 'item',
    url: '/prospect-report',
    target: false
  },
  {
    id: 'primary-customer-report',
    title: <FormattedMessage id="primary-customer-report" />,
    type: 'item',
    url: '/primary-customer-report',
    target: false
  },
  {
    id: 'primary-order-report',
    title: <FormattedMessage id="primary-order-report" />,
    type: 'item',
    url: '/primary-order-report',
    target: false
  },
  {
    id: 'travel-report',
    title: <FormattedMessage id="travel-report" />,
    type: 'item',
    url: '/travel-report',
    target: false
  },
  {
    id: 'travel-claim-report',
    title: <FormattedMessage id="travel-claim-report" />,
    type: 'item',
    url: '/travel-claim-report',
    target: false
  },
  {
    id: 'secondary-customer-report',
    title: <FormattedMessage id="secondary-customer-report" />,
    type: 'item',
    url: '/secondary-customer-report',
    target: false
  },
  {
    id: 'venue-mapping-report',
    title: <FormattedMessage id="venue-mapping-report" />,
    type: 'item',
    url: '/venue-mapping-report',
    target: false
  },
  {
    id: 'market-promotion-report',
    title: <FormattedMessage id="market-promotion-report" />,
    type: 'item',
    url: '/market-promotion-report',
    target: false
  }, 
   //==============================Sooji QR Bag ==================================================//
    
  {
    id: 'bag-request',
    title: <FormattedMessage id="bag-request" />,
    type: 'item',
    url: '/bag-request',
    target: false,
  },
  
   {
    id: 'new-bag-request',
    title: <FormattedMessage id="new-bag-request" />,
    type: 'item',
    url: '/new-bag-request',
    target: false,
  },
  {
    id: 'edit-new-bag-request',
    title: <FormattedMessage id="edit-new-bag-request" />,
    type: 'item',
    url: '/new-bag-request/edit',
    target: false
  },
  {
    id: 'bag-issue',
    title: <FormattedMessage id="bag-issue" />,
    type: 'item',
    url: '/bag-issue',
    target: false,
  },
  {
    id: 'edit-bag-issue',
    title: <FormattedMessage id="edit-bag-issue" />,
    type: 'item',
    url: '/bag-issue/edit',
    target: false
  },
  {
    id: 'store-new-bag-request',
    title: <FormattedMessage id="store-new-bag-request" />,
    type: 'item',
    url: '/store-new-bag-request',
    target: false,
  }, 
  {
    id: 'fill-bag',
    title: <FormattedMessage id="fill-bag" />,
    type: 'item',
    url: '/fill-bag',
    target: false,
  },
  {
    id: 'qc-release',
    title: <FormattedMessage id="qc-release" />,
    type: 'item',
    url: '/qc-release',
    target: false,
  },
  {
    id: 'roasting-process',
    title: <FormattedMessage id="roasting-process" />,
    type: 'item',
    url: '/roasting-process',
    target: false,
  },
   {
    id: 'fumigation-process',
    title: <FormattedMessage id="fumigation-process" />,
    type: 'item',
    url: '/fumigation-process',
    target: false,
  },
   {
    id: 'bag-report',
    title: <FormattedMessage id="bag-report" />,
    type: 'item',
    url: '/bag-report',
    target: false,
  },
  {
    id: 'qr-trans-report',
    title: <FormattedMessage id="qr-trans-report" />,
    type: 'item',
    url: '/qr-trans-report',
    target: false,
  },
   {
    id: 'qr-coded-bag-status-report',
    title: <FormattedMessage id="qr-coded-bag-status-report" />,
    type: 'item',
    url: '/qr-coded-bag-status-report',
    target: false,
  },

  /* Scheme Dashboard Start */
  {
    id: 'scheme-creation',
    title: <FormattedMessage id="scheme-creation" />,
    type: 'item',
    url: '/scheme-creation',
    target: false,
  }, 
  {
    id: 'edit-scheme-creation',
    title: <FormattedMessage id="edit-scheme-creation" />,
    type: 'item',
    url: '/scheme-creation/edit',
    target: false
  },
  {
    id: 'scheme-creation-approval',
    title: <FormattedMessage id="scheme-creation-approval" />,
    type: 'item',
    url: '/scheme-creation-approval',
    target: false,
  },   
  {
    id: 'edit-scheme-creation-approval',
    title: <FormattedMessage id="edit-scheme-creation-approval" />,
    type: 'item',
    url: '/scheme-creation-approval/edit',
    target: false
  },
   {
    id: 'scheme-creation-approval-ch',
    title: <FormattedMessage id="scheme-creation-approval-ch" />,
    type: 'item',
    url: '/scheme-creation-approval-ch',
    target: false,
  },   
  {
    id: 'scheme-creation-approval-bh',
    title: <FormattedMessage id="scheme-creation-approval-bh" />,
    type: 'item',
    url: '/scheme-creation-approval-bh',
    target: false,
  },   
 {
    id: 'scheme-status-master',
    title: <FormattedMessage id="scheme-status-master" />,
    type: 'item',
    url: '/scheme-status-master',
    target: false,
  },
  {
    id: 'scheme-non-eligible-approval',
    title: <FormattedMessage id="scheme-non-eligible-approval" />,
    type: 'item',
    url: '/scheme-non-eligible-approval',
    target: false,
  },
  {
    id: 'edit-scheme-creation',
    title: <FormattedMessage id="edit-scheme-creation" />,
    type: 'item',
    url: '/scheme-creation/edit',
    target: false
  },
  {
    id: 'scheme-gm-approval',
    title: <FormattedMessage id="scheme-gm-approval" />,
    type: 'item',
    url: '/scheme-gm-approval',
    target: false,
  },  
   {
    id: 'scheme-ch-approval',
    title: <FormattedMessage id="scheme-ch-approval" />,
    type: 'item',
    url: '/scheme-ch-approval',
    target: false,
  },  
   {
    id: 'scheme-bh-approval',
    title: <FormattedMessage id="scheme-bh-approval" />,
    type: 'item',
    url: '/scheme-bh-approval',
    target: false,
  },  
   {
    id: 'scheme-ah-credit-note-approval',
    title: <FormattedMessage id="scheme-ah-credit-note-approval" />,
    type: 'item',
    url: '/scheme-ah-credit-note-approval',
    target: false,
  },  
  {
    id: 'scheme-credit-note-report',
    title: <FormattedMessage id="scheme-credit-note-report" />,
    type: 'item',
    url: '/scheme-credit-note-report',
    target: false,
  },  

];

export default pages;
